import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "CallToAction gap-md q-py-20 row items-center justify-between" }

import { ref, watchEffect } from 'vue'
import translate from 'src/common/helpers/language/translate'
import globalTranslateObject from 'src/translate/global.translate'

interface IProps {
  title?: string
  cancelable?: boolean
  saveable?: boolean
  cancelText?: string
  saveText?: string
  disable?: boolean
  loading?: boolean
  isEdit?: boolean
}

interface IEmits {
  (event: 'save', data: void): void
  (event: 'cancel', data: void): void
}


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'CallToAction' },
  __name: 'CallToAction',
  props: {
    title: { default: undefined },
    cancelable: { type: Boolean, default: true },
    saveable: { type: Boolean, default: true },
    cancelText: { default: '' },
    saveText: { default: '' },
    disable: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    isEdit: { type: Boolean, default: false }
  },
  emits: ["save", "cancel"],
  setup(__props: any) {


const props = __props


const { t: globalT } = translate(globalTranslateObject)

const cancelTextRef = ref('')
const saveTextRef = ref('')

watchEffect(() => {
  cancelTextRef.value = !props.cancelText ? globalT('cancel') : props.cancelText
  saveTextRef.value = !props.saveText ? globalT('save') : props.saveText
})

return (_ctx: any,_cache: any) => {
  const _component_k_btn = _resolveComponent("k-btn")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _renderSlot(_ctx.$slots, "title", {}, () => [
      _createElementVNode("div", {
        class: _normalizeClass(["fs-19px fw-600", [__props.isEdit ? 'text-cool-gray-100' : 'text-space-b-100']])
      }, [
        _createTextVNode(_toDisplayString(__props.title) + " ", 1),
        _renderSlot(_ctx.$slots, "append-title")
      ], 2)
    ]),
    (_ctx.$slots['default'])
      ? _renderSlot(_ctx.$slots, "default", { key: 0 })
      : _renderSlot(_ctx.$slots, "actions", { key: 1 }, () => [
          _createElementVNode("div", {
            class: _normalizeClass(["row items-center gap-md", { 'full-width': _ctx.$q.screen.lt.md }])
          }, [
            (__props.cancelable)
              ? (_openBlock(), _createBlock(_component_k_btn, {
                  key: 0,
                  class: _normalizeClass(["CallToAction__btn", { 'flex-1': _ctx.$q.screen.lt.md }]),
                  model: "secondary",
                  label: cancelTextRef.value,
                  size: "md",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('cancel')))
                }, null, 8, ["class", "label"]))
              : _createCommentVNode("", true),
            (__props.saveable)
              ? (_openBlock(), _createBlock(_component_k_btn, {
                  key: 1,
                  class: _normalizeClass(["CallToAction__btn", { 'flex-1': _ctx.$q.screen.lt.md }]),
                  model: "primary",
                  label: saveTextRef.value,
                  size: "md",
                  disable: __props.disable,
                  loading: __props.loading,
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (!__props.disable && _ctx.$emit('save')))
                }, null, 8, ["class", "label", "disable", "loading"]))
              : _createCommentVNode("", true)
          ], 2)
        ])
  ]))
}
}

})